export const ActionTypes = {
  LOAD_REQUEST: "LOAD_REQUEST",
  LOAD_SUCCESS: "LOAD_SUCCESS",
  LOAD_FAIL: "LOAD_FAIL",

  REGISTER_REQUEST: "REGISTER_REQUEST",
  REGISTER_SUCCESS: "REGISTER_SUCCESS",
  REGISTER_FAIL: "REGISTER_FAIL",

  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAIL: "LOGIN_FAIL",

  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",

  LOGOUT_FAIL: "LOGOUT_FAIL",

  PROJECT_LIST_REQUEST: "PROJECT_LIST_REQUEST",
  PROJECT_LIST_SUCCESS: "PROJECT_LIST_SUCCESS",
  PROJECT_LIST_FAIL: "PROJECT_LIST_FAIL",

  PROJECT_DETAILS_REQUEST: "PROJECT_DETAILS_REQUEST",
  PROJECT_DETAILS_SUCCESS: "PROJECT_DETAILS_SUCCESS",
  PROJECT_DETAILS_FAIL: "PROJECT_DETAILS_FAIL",

  PROJECT_SAVE_REQUEST: "PROJECT_SAVE_REQUEST",
  PROJECT_SAVE_SUCCESS: "PROJECT_SAVE_SUCCESS",
  PROJECT_SAVE_FAIL: "PROJECT_SAVE_FAIL",

  PROJECT_DELETE_REQUEST: "PROJECT_DELETE_REQUEST",
  PROJECT_DELETE_SUCCESS: "PROJECT_DELETE_SUCCESS",
  PROJECT_DELETE_FAIL: "PROJECT_DELETE_FAIL",

  PROJECT_READ_REQUEST: "PROJECT_READ_REQUEST",
  PROJECT_READ_SUCCESS: "PROJECT_READ_SUCCESS",
  PROJECT_READ_FAIL: "PROJECT_READ_FAIL",

  PROJECT_RATING_REQUEST: "PROJECT_RATING_REQUEST",
  PROJECT_RATING_SUCCESS: "PROJECT_RATING_SUCCESS",
  PROJECT_RATING_FAIL: "PROJECT_RATING_FAIL",

  CREATE_MESSAGE: "CREATE_MESSAGE",
  GET_ERRORS: "GET_ERRORS",
  CLEAR_PROJECTS: "CLEAR_PROJECTS",
};
